import { service } from '@ember/service';
import BaseEditionForm from 'parog-web/components/mici/base-edition-form';
import CrohnSurveyFilledJournalEvent from 'parog-web/models/crohn-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import MiciBaseEditionFormEditionForm from './base-edition-form/edition-form/index';

export default class MiciCrohnSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  static override forcDisplayName = 'Questionnaire sur ma maladie';
  static override fullComponentId = 'mici/crohn-survey-edition-form';
  static override journalEventClass = CrohnSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  override get currentSections(): Array<string> {
    return [
      'stoolsNumber',
      ...this.#abdominalPainSections,
      'wellBeing',
      ...this.#anusSections,
      ...this.#fistulasSections,
      ...this.#articularPainSections,
      'mouthUlcers',
      'skinSymptoms',
      ...this.#eyeSymptomsSections,
      ...this.#feverSections,
      'weight',
      'repeatedVomiting',
      'transitBlockage'
    ];
  }

  override get forcDisplayName(): string {
    return this.session.medic ? 'Questionnaire Crohn' : 'Symptômes';
  }

  get #abdominalPainSections(): string[] {
    if (this.changeset.get('abdominalPain')) {
      return ['abdominalPain', 'abdominalPainIntensity'];
    }
    return ['abdominalPain'];
  }

  get #anusSections(): string[] {
    if (this.changeset.get('anusSymptoms')) {
      return ['anusSymptoms', 'anusSymptomsFrequency'];
    }
    return ['anusSymptoms'];
  }

  get #articularPainSections(): string[] {
    if (this.changeset.get('articularPain')) {
      return ['articularPain', 'articularPainSeverity'];
    }
    return ['articularPain'];
  }

  get #eyeSymptomsSections(): string[] {
    if (this.changeset.get('eyeSymptoms')) {
      return [
        'eyeSymptoms',
        'eyeSymptomsRedEye',
        'eyeSymptomsPainful',
        'eyeSymptomsSight'
      ];
    }
    return ['eyeSymptoms'];
  }

  get #feverSections(): string[] {
    if (this.changeset.get('fever')) {
      return ['fever', 'feverLevel'];
    }
    return ['fever'];
  }

  get #fistulasSections(): string[] {
    if (this.changeset.get('hasFistulas')) {
      return [
        'hasFistulas',
        'fistulasPain',
        'fistulasEmbarrassment',
        'fistulasFlow',
        'fistulasPainSkin',
        'fistulasMovement'
      ];
    }
    return ['hasFistulas'];
  }

  override afterCompleted = () => {
    this.analytics.trackPatientMeasurement('crohn-survey');
    if (this.args.afterCompleted) this.args.afterCompleted();
  };

  <template>
    <BaseEditionForm
      @changeset={{this.changeset}}
      @save={{this.onSave}}
      @currentSections={{this.currentSections}}
      @patient={{this.patient}}
    >
      <:title>
        Au cours des 7 derniers jours
      </:title>
    </BaseEditionForm>
  </template>
}
